import { request } from '../request'

type UrlResponse = { url: string };

export class UploadsService {

  prepareAndUpload(f: File): Promise<any> {
    const reader = new FileReader()
    const p = new Promise((resolve, reject) => {
      reader.onloadend = () => {
        this.uploadFile(f.name, f.type, reader.result).then((resp) => {
          resolve(resp.url)
        }).catch(() => {
          reject()
        })
      }
    })
    reader.readAsArrayBuffer(f)
    return p
  }

  uploadFile(key: string, contentType: string, body: string | ArrayBuffer): Promise<UrlResponse> {
    const path = 'uploads/' + Math.random().toString(36).substring(4) + '/' + key
    return new Promise((resolve, reject) => {
      this.signedUrl(path).then(resp => {
        this.uploadContents(resp.url, contentType, body).then(() => {
          resolve({ url: resp.url.split('?')[0] })
        }).catch(reject)
      }).catch(reject)
    })
  }

  private signedUrl(key: string): Promise<UrlResponse> {
    return request.put(`/api/uploads/signed_url.json`, { key })
  }

  private uploadContents(signedUrl: string, contentType: string, body: string | ArrayBuffer): Promise<UrlResponse> {
    return request.put(signedUrl, body, { headers: { 'Content-Type': contentType || 'application/octet-stream' } })
  }

}
